import { render, staticRenderFns } from "./permisos.vue?vue&type=template&id=a1394d6c"
import script from "./permisos.vue?vue&type=script&lang=js"
export * from "./permisos.vue?vue&type=script&lang=js"
import style0 from "./permisos.vue?vue&type=style&index=0&id=a1394d6c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports